export default __webpack_public_path__ + "static/media/archer.d974c02d.svg";